import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=54d5124f&"
import script from "./TasksList.vue?vue&type=script&lang=js&"
export * from "./TasksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d5124f')) {
      api.createRecord('54d5124f', component.options)
    } else {
      api.reload('54d5124f', component.options)
    }
    module.hot.accept("./TasksList.vue?vue&type=template&id=54d5124f&", function () {
      api.rerender('54d5124f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/TasksList.vue"
export default component.exports